export default __webpack_public_path__ + "static/media/pictogramBeaconShopping40.8407896d.svg";